import { Tag } from 'antd';

const ListItem = ({label, content, separate, color, background, delimiter=", "}) => {
    const normalizedContent = content == null ? "" : String(content).trim();
    const values = separate
        ? normalizedContent.split(delimiter).map(item => item.trim()).filter(Boolean)
        : [normalizedContent];
    const displayValues = values.length > 0 && values[0] !== "" ? values : ["."];

    return (
        <div style={{width: '100%', marginBottom: '5px'}}>
            <span className='variant-thrid-title'>
                {label}: 
            </span>
            {displayValues.map((value, idx) => (
                <Tag
                    key={`${label}-${value}-${idx}`}
                    style={value === "." ? undefined : {
                        background,
                        color,
                        fontWeight: separate || background !== "transparent" ? 'bold' : undefined
                    }}
                >
                    {value}
                </Tag>
            ))}
        </div>
    )
};

export default ListItem
